<template>
    <el-tabs type="border-card" @tab-click="SetData" v-model="Act">
      <el-tab-pane label="基础配置" name="Basic">
            <AdminBasic v-if="Act == 'Basic'"></AdminBasic>
      </el-tab-pane>
      <el-tab-pane label="信息项配置" name="Info">
            <AdminInfo v-if="Act == 'Info'"></AdminInfo>
      </el-tab-pane>
      <el-tab-pane label="规则项配置" name="Rules">
            <AdminRules v-if="Act == 'Rules'"></AdminRules>
      </el-tab-pane>
      <el-tab-pane label="专家领域配置" name="LingYu">
            <AdminLingYu v-if="Act == 'LingYu'"></AdminLingYu>
      </el-tab-pane>
      <el-tab-pane label="保密协议配置" name="BMXY">
            <div class="XyHead">
                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"/>
                <Editor style="height: 500px; overflow-y: hidden;" v-model="EditorCont" :defaultConfig="editorConfig" @onCreated="onCreated" />
            </div>
            <el-button v-throttle type="primary" size="mini" @click="SucXieYi">保存</el-button>
      </el-tab-pane>
    </el-tabs>
</template>

<script>
    import { Editor, Toolbar,toolbarConfig } from '@wangeditor/editor-for-vue'
    export default {
        data() {
            return {
                Act:"Basic",
                editor: null,
                EditorCont: '',
                editorConfig: { placeholder: '请输入内容...' },
                toolbarConfig: {
                  excludeKeys: ['uploadImage', 'uploadVideo']
                }
            };
        },
        components: { Editor, Toolbar },
        mounted() {
            
        },
        methods: {
            SetData(tab) {
                this.Act = tab.name;
            },
            onCreated(editor) {
                this.editor = Object.seal(editor)
                this.$get('/admin/expert_field/xieyi',{
                }).then(res=>{
                    if(res){
                        this.EditorCont = res.data.content;
                    }
                })
            },
            SucXieYi() {
                this.$post('/admin/expert_field/xieyiEdit',{
                    id:"",
                    content:this.EditorCont
                }).then(res=>{
                    if(res){
                        this.$message.success('保存成功');
                    }
                })
            }
        },
        beforeDestroy() {
          const editor = this.editor
          if (editor == null) return
          editor.destroy() // 组件销毁时，及时销毁编辑器
        },
    }
</script>

<style scoped>
    .XyHead{
        border:1px solid #ccc;
        margin-bottom: 10px;
    }
</style>